import { render, staticRenderFns } from "./PowraD.vue?vue&type=template&id=6e6ff6a7&"
import script from "./PowraD.vue?vue&type=script&lang=js&"
export * from "./PowraD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports